export const transformStringToPrice = (value: string): number => {
  if (!value) {
    return 0;
  }

  return parseFloat(value.replace(/\./i, "").replace(/,/i, "."));
};
